<style type="text/css">
  .drop-zone {
    /*Sort of important*/
    width: 300px;
    /*Sort of important*/
    height: 200px;
    position:absolute;
    left:50%;
   /* top:100px;*/
    margin-left:-150px;
    border: 2px dashed rgba(0,0,0,.3);
    border-radius: 20px;
    font-family: Arial;
    text-align: center;
    position: relative;
    line-height: 180px;
    font-size: 20px;
    color: rgba(0,0,0,.3);
}

    .drop-zone input {
        /*Important*/
        position: absolute;
        /*Important*/
        cursor: pointer;
        left: 0px;
        top: 0px;
        /*Important This is only comment out for demonstration purposes.
        opacity:0; */
    }

    /*Important*/
    .drop-zone.mouse-over {
        border: 2px dashed rgba(0,0,0,.5);
        color: rgba(0,0,0,.5);
    }


/*If you dont want the button*/
.clickHere {
    position: absolute;
    cursor: pointer;
    left: 50%;
    top: 50%;
    margin-left: -50px;
    margin-top: 20px;
    line-height: 26px;
    color: white;
    font-size: 12px;
    width: 100px;
    height: 26px;
    border-radius: 4px;
    background-color: #3b85c3;

}

    .clickHere:hover {
        background-color: #4499DD;

    }
</style>
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-10">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">
              Upload Uneda Inventory
            </h4>
          
          </div>
          <div class="card ">
          
          <div class="card-body ">
          
            <div class="tab-content tab-space">
              <div class="tab-pane active" id="link1">
               

<div class="col-md-12" *ngIf="this.unedaEnabled == 0">
  <img src="assets/img/restricted-area.png" style="width: 80%">
<p>You don't have the permissions to access to this area.</p>
</div>

  <div class="col-md-12" *ngIf="this.unedaEnabled == 1">
                                        
                                       <div style="margin-bottom: 20px" class="row">
                                         <div class="col-md-3">
                                            <div class="form-check">
                    <label class="form-check-label" style="font-weight: 700;">
                      <input (change)="typechange()" class="form-check-input" type="radio" name="unedaTypeForm" [(ngModel)]="this.unedaType" #unedaTypeForm="ngModel" value="IQ" checked> Sync with IQ
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check">
                    <label class="form-check-label" style="font-weight: 700;">
                      <input (change)="typechange()" class="form-check-input" type="radio" name="unedaTypeForm" [(ngModel)]="this.unedaType" #unedaTypeForm="ngModel" value="INVENTORY" > Manually Sync (CSV File)
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                                         </div>
                                       </div>

                                      <div style="margin-top: 30px; position: relative;" *ngIf="this.unedaType == 'INVENTORY'">
                                          <h4>Upload File</h4>
                                          <hr>
                                        <div class="col-md-3 bg">
                                            <div class="loader" id="loader-4">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                              <div style=" position: absolute;
    top: -250px;
    width: 100%; display: none" class="loader col-md-12">
                                <i class="material-icons">
autorenew
</i> Hold on! our bot is importing the data.

                              </div>
                                        <div class="drop-zone">
                                            Drop CSV File here...
                                            <div class="clickHere">
                                                or click here..
                                                <input accept=".csv" type="file" style="position: absolute;
                                                                          cursor: pointer;
                                                                          left: -100px;
                                                                          top: -110px;
                                                                          height: 200px;
                                                                          width: 300px;
                                                                          opacity: 0;" id="sendfile" (change)="onFileSend($event)">
                                            </div>
                                        </div>
                                        
                                        <div class="alert alert-success" style="display: none" id="confirmuploadedfile" role="alert">
                                            The file has been uploaded successfully!
                                        </div>

                                         <div class="alert alert-danger" style="display: none" id="erroruploadedfile" role="alert">
                                           Sorry, only *.csv files are supported
                                        </div>

                                        <p>
                                          <a href="https://greenteksolutionsllc.com/inventory.csv"><i class="material-icons">
attachment
</i> Download inventory template</a>
                                        </p>
                                        <p style="    font-style: italic;">
                                          Last time inventory was uploaded: {{lastSync | Fechagts}}
                                        </p>
                                      </div>

                                  <div class="row" *ngIf="this.unedaType == 'IQ'">   

<div class="col-md-6">
        <div class="card ">
          <div class="card-header card-header-rose card-header-icon">
            <div class="card-icon">
              <i class="material-icons">contacts</i>
            </div>
            <h4 class="card-title">IQ Sync Configuration</h4>
          </div>
          <div class="card-body ">
            <form class="form-horizontal">
              <div class="row">
                <label class="col-md-3 col-2 col-form-label">IQ Session API KEY</label>
                <div class="col-md-9 col-9">
                  <mat-form-field class="example-full-width">
                    <input matInput name="unedaIqKeyForm" [(ngModel)]="this.unedaIqKey" #unedaIqKeyForm="ngModel" type="text">
                  </mat-form-field>
                </div>
              </div>
           
            
            </form>
          </div>
          <div class="card-footer ">
            <div class="row">
              <div class="col-md-9">
                <button mat-raised-button (click)="iqsync()" class="btn btn-fill btn-rose">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">

<p style="    margin-top: 20%;">You must enter the API Session Key of your IQ Account. If you have questions, ask to the support team, we are happy to help</p>
      </div>

                                  </div>   

 </div>
              </div>
             
              
          
               
            </div>
          </div>
        </div>
          <div class="card-body">
            <form>
            
              
              
              
              
              <div class="clearfix"></div>
            </form>
          </div>
        </div>


 

     

      </div>

    </div>
  </div>
</div>
